import { evaluationIcon } from './SiteHealthStyles'
import type { EvaluationIconProps } from './SiteHealthStyles.types'

export default function EvaluationIcon({
  state,
  className,
}: EvaluationIconProps) {
  const metadata = evaluationIcon(state)
  const Icon = metadata.icon

  return (
    <Icon
      aria-label={metadata.label}
      className={className ?? `size-4 ${metadata.className}`}
      aria-hidden={className ? undefined : false}
    />
  )
}
